import { Building2, GitBranch, History, KeyRound, LogIn, LogOut, Pencil, ShieldAlert, UserCog, Database, type LucideIcon } from 'lucide-react';
import type { AuditEvent } from '@quds/shared';

const EXACT: Record<string, LucideIcon> = {
  'auth.login.succeeded': LogIn,
  'auth.login.failed': ShieldAlert,
  'auth.logout': LogOut,
  'business.created': Building2,
  'business.updated': Pencil,
  'admin_user.password_changed': KeyRound,
  'admin_user.password_change_failed': ShieldAlert,
  'admin_user.password_reset': KeyRound,
};

const PREFIX: [string, LucideIcon][] = [
  ['branch.', GitBranch],
  ['admin_user.', UserCog],
  ['system.', Database],
];

export function activityIcon(action: string): LucideIcon {
  return EXACT[action] ?? PREFIX.find(([p]) => action.startsWith(p))?.[1] ?? History;
}

/** Who performed the event: the admin, the attempted email for failed sign-ins, or "System" for CLI tasks. */
export function actorLabel(event: AuditEvent): string {
  return event.actor.name ?? event.actor.email ?? 'System';
}

/** `fullAudit`: only returned by the API to users holding `audit.read`. */
export const ACTIVITY_FILTERS = [
  { value: 'auth.', label: 'Sign-in', fullAudit: true },
  { value: 'business.', label: 'Pharmacies', fullAudit: false },
  { value: 'branch.', label: 'Branches', fullAudit: false },
  { value: 'admin_user.', label: 'Admin users', fullAudit: true },
  { value: 'system.', label: 'System', fullAudit: true },
] as const;
